import * as bootstrap from 'bootstrap'
import '@popperjs/core'
import IMask from 'imask'
import htmx from 'htmx.org'

window.bootstrap = bootstrap
window.htmx = htmx

// document.addEventListener('DOMContentLoaded', setScroll)

window.addMasks = () => {
    const celular = document.getElementById('id_celular')
    if (celular) IMask(celular, { mask: '(00) 00000-0000' })
    const cep = document.getElementById('id_cep')
    if (cep) IMask(cep, { mask: '00000-000' })
    const cpfs = document.querySelectorAll('.cpf')
    if (cpfs) cpfs.forEach(c => IMask(c, { mask: '000.000.000-00' }))
    const cpf = document.getElementById('id_cpf')
    if (cpf) IMask(cpf, { mask: '000.000.000-00' })
    const cartao = document.getElementById('card_number')
    if (cartao) IMask(cartao, { mask: '0000 0000 0000 0000' })
}
document.addEventListener('DOMContentLoaded', window.addMasks)

// function setScroll() {
//     let pos = window.scrollY
//     document.addEventListener('scroll', () => {
//         pos = window.scrollY
//         setBg(pos)
//     })
//     setBg(pos)
// }

// function setBg(pos) {
//     const mainNav = document.querySelector('#main-nav')
//     if (pos > 5) {
//         if (mainNav && mainNav.classList.contains('bg-transparent')) {
//             mainNav.classList.remove('bg-transparent')
//             mainNav.classList.add('bg-dark')
//         }
//     } else {
//         if (mainNav && mainNav.classList.contains('bg-dark')) {
//             mainNav.classList.remove('bg-dark')
//             mainNav.classList.add('bg-transparent')
//         }
//     }
// }

window.buscarCEP = (ev) => {
    const cep = ev.target.value
    if (/^\d{5}-\d{3}$/.test(cep)) {
        fetch('https://viacep.com.br/ws/' + cep + '/json/')
            .then(resp => resp.json())
            .then(data => {
                if (data.erro) {
                    alert('CEP não encontrado.')
                } else {
                    const endereco = document.getElementById('id_endereco')
                    const bairro = document.getElementById('id_bairro')
                    const cidade = document.getElementById('id_cidade')
                    const estado = document.getElementById('id_estado')
                    if (endereco) endereco.value = data.logradouro
                    if (bairro) bairro.value = data.bairro
                    if (cidade) cidade.value = data.localidade
                    if (estado) estado.value = data.uf
                }
            })
    }
}

